// ROI / proof-point metrics shown across the landing page.
// Update with real measured numbers as they become available.

export const heroStats = [
  { value: '10 min', label: 'Average setup time' },
  { value: '24/7', label: 'Always responding' },
  { value: '< 30s', label: 'Reply latency' },
];

// Per-feature metric badges keyed by feature title (matching Features.jsx).
export const featureMetrics = {
  'AI Powered WhatsApp Replies': '< 30s avg reply time',
  'Train It with Your Business Knowledge': 'Answers from your docs only',
  'Capture Leads Automatically': '+40% qualified leads',
  'Book Appointments Seamlessly': '+62 appointments / month',
  'Send Emails on Your Behalf': 'Hands off follow up',
  'Always On, Always Responding': '24/7 uptime',
  'Test Before You Go Live': '0 risk dry runs',
};

export const trustBadges = [
  'TLS 1.3 encryption',
  'No data sold to third parties',
  'GDPR aware data handling',
  'Knowledge base only',
];
